import Container from "./containers/Container";

const App: React.FC = () => {
  return <Container />;
};

export default App;
